export default __webpack_public_path__ + "static/media/momo3.21e8c7f5.jpg";